// filepath: d:\Coding\Web Dev\ComplaintManagementSys\Frontend\inquiry-frontend\src\services\category.service.ts
// src/services/category.service.ts
import axios from 'axios';
import authHeader from './auth-header';
import { API_URL } from '../config/api.config';

// Get all categories
const getAllCategories = async () => {
  try {
    const response = await axios.get(`${API_URL}/categories`, { 
      headers: authHeader()
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: 'Failed to fetch categories' };
  }
};

// Get category details by ID
const getCategoryDetails = async (categoryId: number) => {
  try {
    const response = await axios.get(`${API_URL}/categories/${categoryId}`, { 
      headers: authHeader() 
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: 'Failed to fetch category details' };
  }
};

// Create a new category
const createCategory = async (title: string, faculty_id: number = 1) => {
  try {
    console.log('Creating category with:', { title, faculty_id });
    const response = await axios.post(
      `${API_URL}/categories`, 
      { title, faculty_id }, 
      { headers: authHeader() }
    );
    return response.data;
  } catch (error: any) {
    console.error('Error creating category:', error.response?.data);
    throw error.response?.data || { message: 'Failed to create category' };
  }
};

// Update a category
const updateCategory = async (categoryId: number, title: string) => {
  try {
    const response = await axios.put(
      `${API_URL}/categories/${categoryId}`, 
      { title }, 
      { headers: authHeader() }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: 'Failed to update category' };
  }
};

// Delete a category
const deleteCategory = async (categoryId: number) => {
  try {
    const response = await axios.delete(
      `${API_URL}/categories/${categoryId}`, 
      { headers: authHeader() }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: 'Failed to delete category' };
  }
};

// Get categories assigned to an admin user
const getCategoriesForAdmin = async (adminUserId: number) => {
  try {
    const response = await axios.get(
      `${API_URL}/admin-categories/${adminUserId}`,
      { headers: authHeader() }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: 'Failed to fetch admin categories' };
  }
};

// Assign categories to an admin user
const assignCategoriesToAdmin = async (adminUserId: number, payload: { categoryIds: number[] }) => {
  try {
    const response = await axios.post(
      `${API_URL}/admin-categories/${adminUserId}`,
      payload,
      { headers: authHeader() }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: 'Failed to assign categories to admin' };
  }
};

// Get all admin-category assignments (for dashboard view)
const getAllAdminCategoryAssignments = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/admin-categories/all-assignments`,
      { headers: authHeader() }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: 'Failed to fetch admin-category assignments' };
  }
};

const CategoryService = {
  getAllCategories,
  getCategoryDetails,
  createCategory,
  updateCategory,
  deleteCategory,
  getCategoriesForAdmin,
  assignCategoriesToAdmin,
  getAllAdminCategoryAssignments
};

export default CategoryService;
